module.exports = __webpack_public_path__ + "static/media/share-dialog-bg.e493d591.png";